import { z } from 'zod'

/**
 * Defines the expected values of user role types and maps to the records
 * in the role_type table
 */
export enum RoleType {
  Owner = 'OWNER',
  Manager = 'MANAGER',
  Member = 'MEMBER',
  Observer = 'OBSERVER',
  Supporter = 'SUPPORTER'
}

/**
 * Zod schema for user role types
 */
export const roleTypeSchema = z.enum(RoleType)
const roleTypeValues = Object.values(RoleType)

// Roles that allow modification (i.e., can't change OWNER or SUPPORTER)
export const modifiableRoles = roleTypeValues.filter(
  (r) => r !== RoleType.Owner && r !== RoleType.Supporter
)

/**
 * Checks if the string is a valid role type
 *
 * @param s
 */
export const isRoleType = (s: string | null): s is RoleType =>
  roleTypeValues.includes(s as RoleType)
